// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --bl: #1a56db;
  --bl-dark: #0f2d5e;
  --bl5: #e8f0fe;
  --gr: #057a55;
  --red: #e02424;
  --amb: #d97706;
  --pur: #7e3af2;
  --txt: #111827;
  --txt2: #374151;
  --txt3: #6b7280;
  --txt4: #9ca3af;
  --b1: #e5e7eb;
  --b2: #d1d5db;
  --bg2: #f3f4f6;
  --wh: #fff
}

.shell {
  position: relative;
  height: 99%;
  width: 100%;
  /* border-radius: 10px; */
  overflow: hidden;
  border: 1px solid var(--b1);
  box-shadow: 0 1px 4px rgba(0, 0, 0, .07)
}

.map-full {
  position: absolute;
  inset: 0;
  background: #eef2f7;
  z-index: 0
}

/* TOPBAR */
.topbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background: var(--bl-dark);
  padding: 7px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between
}

.tb-brand {
  display: flex;
  align-items: center;
  gap: 8px
}

.tb-logo {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: rgba(255, 255, 255, .18);
  display: flex;
  align-items: center;
  justify-content: center
}

.tb-name {
  font-size: 13px;
  font-weight: 500;
  color: #fff
}

.tb-sep {
  color: rgba(255, 255, 255, .3);
  margin: 0 2px
}

.tb-sub {
  font-size: 10px;
  color: rgba(255, 255, 255, .6)
}

.tb-pill {
  background: rgba(255, 255, 255, .12);
  border: 0.5px solid rgba(255, 255, 255, .2);
  border-radius: 4px;
  padding: 2px 8px;
  font-size: 10px;
  color: rgba(255, 255, 255, .85)
}

/* STATBAR MODERNIZED */
.statbar {
  position: absolute;
  top: 0px;
  width: 100%;
  /* left: 50%;
  transform: translateX(-50%); */
  z-index: 100;
  background: rgba(255, 255, 255, 0.9);
  -webkit-backdrop-filter: blur(12px);
          backdrop-filter: blur(12px);
  padding: 8px 24px;
  display: flex;
  gap: 15px;
  align-items: center;
  /* border-radius: 50px; */
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);
  border: 1px solid var(--second-color);
  white-space: nowrap;
}

.stg {
  position: relative;
  display: flex;
  align-items: center;
  /* gap: 8px; */
}

.stg-lbl {
  color: #64748b;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: .05em;
  font-weight: 800;
}

.pill {
  border-radius: 8px;
  padding: 4px 12px;
  font-size: 14px;
  font-weight: 800;
  min-width: 30px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.pill:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.p-up {
  background: #dcfce7;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.p-dn {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.p-uk {
  background: #f1f5f9;
  color: #475569;
  border: 1px solid #e2e8f0;
}

.p-odd {
  background: #f3e8ff;
  color: #7e22ce;
  border: 1px solid #e9d5ff;
}

.p-ex {
  background: #fef3c7;
  color: #b45309;
  border: 1px solid #fde68a;
}

/* Counter Hover Tooltip */
.stg-tooltip {
  position: absolute;
  top: calc(100% + 12px);
  left: 50%;
  transform: translateX(-50%) translateY(10px);
  width: 340px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  padding: 0;
  visibility: hidden;
  opacity: 0;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 1000;
  pointer-events: none;
  border: 1px solid #f1f5f9;
  overflow: hidden;
}

.stg:hover .stg-tooltip {
  visibility: visible;
  opacity: 1;
  transform: translateX(-50%) translateY(0);
}

.stg-tooltip::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  border-width: 8px;
  border-style: solid;
  border-color: transparent transparent #ffffff transparent;
}

/* FILTROS + CAPAS */
.top-left-row {
  position: absolute;
  top: 80px;
  left: 10px;
  z-index: 8;
  display: flex;
  align-items: flex-start;
  gap: 8px
}

.panel-filtros {
  width: 210px;
  background: rgba(255, 255, 255, .97);
  border: 1px solid var(--b1);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, .12)
}

.panel-hdr {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 10px;
  cursor: pointer;
  border-radius: 8px;
  -webkit-user-select: none;
          user-select: none
}

.panel-hdr.expanded {
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid var(--b1)
}

.panel-hdr:hover {
  background: var(--bg2)
}

.panel-hdr-left {
  display: flex;
  align-items: center;
  gap: 7px
}

.panel-hdr-txt {
  font-size: 11px;
  font-weight: 500;
  color: var(--txt2)
}

.chev {
  color: var(--txt3);
  display: flex;
  align-items: center;
  transition: transform .18s
}

.chev.open {
  transform: rotate(180deg)
}

.panel-body {
  padding: 9px 10px;
  display: flex;
  flex-direction: column;
  gap: 7px
}

.panel-body.hidden {
  display: none
}

.f-lbl {
  font-size: 9px;
  color: var(--txt3);
  text-transform: uppercase;
  letter-spacing: .06em;
  margin-bottom: 2px
}

.f-sel {
  width: 100%;
  border: 1px solid var(--b1);
  border-radius: 4px;
  color: var(--txt2);
  font-size: 10px;
  padding: 3px 5px;
  background: var(--wh);
  outline: none
}

.f-inp {
  width: 100%;
  border: 1px solid var(--b1);
  border-radius: 4px;
  color: var(--txt2);
  font-size: 10px;
  padding: 3px 5px;
  background: var(--wh);
  outline: none
}

.f-inp::placeholder {
  color: var(--txt4)
}

.sbts {
  display: flex;
  gap: 3px;
  flex-wrap: wrap
}

.sbt {
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 9px;
  cursor: pointer;
  border: 1px solid;
  font-weight: 500
}

.sbt-g {
  background: #d1fae5;
  color: #065f46;
  border-color: #a7f3d0
}

.sbt-r {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5
}

.sbt-u {
  background: var(--bg2);
  color: var(--txt3);
  border-color: var(--b2)
}

.sbt-a {
  background: #fef3c7;
  color: #92400e;
  border-color: #fde68a
}

.sbt-p {
  background: #ede9fe;
  color: #5b21b6;
  border-color: #c4b5fd
}

.btn-capas {
  background: rgba(255, 255, 255, .97);
  border: 1px solid var(--b1);
  border-radius: 8px;
  padding: 7px 14px;
  font-size: 11px;
  font-weight: 500;
  color: var(--bl);
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 7px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, .12);
  white-space: nowrap;
  height: 34px
}

.btn-capas:hover {
  background: var(--bl5)
}

.panel-capas {
  position: absolute;
  top: 42px;
  left: 0;
  width: 195px;
  background: rgba(255, 255, 255, .97);
  border: 1px solid var(--b1);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, .12);
  display: none;
  z-index: 22
}

.panel-capas.visible {
  display: block
}

.capas-title {
  font-size: 11px;
  font-weight: 500;
  color: var(--txt2);
  text-align: center;
  padding: 7px 10px;
  border-bottom: 1px solid var(--b1);
  border-radius: 8px 8px 0 0
}

.capas-item {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 7px 12px;
  border-bottom: 1px solid var(--bg2);
  cursor: pointer;
  font-size: 11px;
  color: var(--txt2)
}

.capas-item:last-child {
  border-bottom: none;
  border-radius: 0 0 8px 8px
}

.capas-item:hover {
  background: var(--bg2)
}

.capas-cb {
  width: 16px;
  height: 16px;
  border-radius: 3px;
  border: 1.5px solid var(--bl);
  background: var(--bl5);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0
}

/* LEYENDA */
.panel-leyenda {
  position: absolute;
  bottom: 10px;
  left: 10px;
  z-index: 20;
  background: rgba(255, 255, 255, .95);
  border: 1px solid var(--b1);
  border-radius: 8px;
  padding: 8px 10px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .1)
}

.leg-lbl {
  font-size: 9px;
  color: var(--txt3);
  text-transform: uppercase;
  letter-spacing: .06em;
  margin-bottom: 4px
}

.leg-row {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 9px;
  color: var(--txt3);
  margin-bottom: 3px
}

.leg-row:last-child {
  margin-bottom: 0
}

.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  display: inline-block;
  flex-shrink: 0
}

/* EVENTOS */
.panel-eventos {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 20;
  background: rgba(255, 255, 255, .97);
  border-top: 1px solid var(--b1);
  box-shadow: 0 -4px 16px rgba(0, 0, 0, .1)
}

.ev-hdr {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 0 12px;
  height: 36px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: var(--third-color);
}

.ev-hdr:hover {
  background: rgba(0, 43, 130, 0.979);
}

.ev-hdr.has-border {
  border-bottom: 1px solid var(--b1)
}

.ev-title {
  font-size: 10px;
  font-weight: 500;
  color: var(--white-color);
  text-transform: uppercase;
  letter-spacing: .06em;
  white-space: nowrap
}

.ev-cnt-pill {
  padding: 1px 8px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 700;
  min-width: 24px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid transparent;
}

.ev-cnt-pill.total {
  background: #e8f0fe;
  color: #1a56db;
  border-color: #c3dafe;
}

.ev-cnt-pill.problem {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
}

.ev-cnt-pill.resolved {
  background: #ecfdf5;
  color: #065f46;
  border-color: #a7f3d0;
}

/* Severity Counter Split Style - Static & Distinct */
.sev-counter {
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  overflow: hidden;
  font-size: 9px;
  font-weight: 700;
  border: 1px solid;
  margin-right: 4px;
  cursor: default;
  /* transition: transform 0.1s; */
}

.sev-counter .label {
  padding: 1px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  filter: brightness(0.95);
  /* Slightly darker */
}

.sev-counter .value {
  padding: 1px 8px;
  background: var(--wh);
  display: flex;
  align-items: center;
  justify-content: center;
}

.sev-counter.sev5 {
  border-color: #fca5a5;
  color: #991b1b;
}

.sev-counter.sev5 .label {
  background: #fee2e2;
}

.sev-counter.sev5 .value {
  background: #fff5f5;
}

.sev-counter.sev4 {
  border-color: #fde68a;
  color: #92400e;
}

.sev-counter.sev4 .label {
  background: #fef3c7;
}

.sev-counter.sev4 .value {
  background: #fffdf2;
}

.sev-counter.sev3 {
  border-color: #fdba74;
  color: #9a3412;
}

.sev-counter.sev3 .label {
  background: #fff7ed;
}

.sev-counter.sev3 .value {
  background: #fffcf0;
}

.sev-counter.sev2 {
  border-color: #c4b5fd;
  color: #5b21b6;
}

.sev-counter.sev2 .label {
  background: #ede9fe;
}

.sev-counter.sev2 .value {
  background: #f5f3ff;
}

.sev-counter.sev1 {
  border-color: #93c5fd;
  color: #1e40af;
}

.sev-counter.sev1 .label {
  background: #e8f0fe;
}

.sev-counter.sev1 .value {
  background: #f0f7ff;
}

.ev-sev {
  display: flex;
  align-items: center;
  gap: 4px
}

.sev-badge {
  border-radius: 3px;
  padding: 1px 5px;
  font-size: 8px;
  font-weight: 500;
  border: 1px solid;
  white-space: nowrap
}

.sev-sev5 {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5
}

.sev-sev4 {
  background: #fef3c7;
  color: #92400e;
  border-color: #fde68a
}

.sev-sev2 {
  background: #ede9fe;
  color: #5b21b6;
  border-color: #c4b5fd
}

.sev-sev1 {
  background: #e8f0fe;
  color: #1e40af;
  border-color: #93c5fd
}

.ev-actions-bar {
  margin-left: auto;
  display: flex;
  gap: 4px;
  align-items: center;
  flex-shrink: 0
}

/* Custom Tooltip System */
[data-tooltip] {
  position: relative;
}

[data-tooltip]::before {
  content: attr(data-tooltip);
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  padding: 4px 10px;
  background: #1e293b;
  color: #f8fafc;
  font-size: 9px;
  font-weight: 500;
  border-radius: 4px;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 1000;
  pointer-events: none;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

[data-tooltip]::after {
  content: '';
  position: absolute;
  bottom: calc(100% + 3px);
  left: 50%;
  transform: translateX(-50%);
  border-width: 5px;
  border-style: solid;
  border-color: #1e293b transparent transparent transparent;
  opacity: 0;
  visibility: hidden;
  transition: all 0.2s ease;
  z-index: 1000;
  pointer-events: none;
}

[data-tooltip]:hover::before,
[data-tooltip]:hover::after {
  opacity: 1;
  visibility: visible;
}

/* Info Marker Modal Modernized */
.info-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(15, 23, 42, 0.6);
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.info-modal-content {
  background: var(--wh);
  width: 80%;
  height: 80%;
  border-radius: 12px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.info-modal-hdr {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 20px;
  border-bottom: 1px solid #f1f5f9;
  position: relative;
}

.info-modal-hdr h2 {
  font-size: 15px;
  font-weight: 600;
  color: var(--third-color);
  margin: 0;
}

.info-modal-close {
  position: absolute;
  right: 16px;
  top: 14px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: #f1f5f9;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
}

.info-modal-close:hover {
  background: #fee2e2;
  color: #ef4444;
}

.info-device-bar {
  background: #1e3a8a;
  color: #ffffff;
  display: grid;
  grid-template-columns: 1.5fr 1fr 0.8fr 0.8fr 0.8fr;
  padding: 10px 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.025em;
}

.info-device-row {
  display: grid;
  grid-template-columns: 1.5fr 1fr 0.8fr 0.8fr 0.8fr;
  padding: 12px 20px;
  align-items: center;
  font-size: 12px;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}

.info-device-sel-container {
  display: flex;
  align-items: center;
  gap: 8px;
}

.info-device-sel {
  padding: 6px 12px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
  font-size: 12px;
  color: #1e293b;
  width: 100%;
  outline: none;
}

.status-badge {
  font-weight: 800;
  text-transform: uppercase;
}

.status-badge.down {
  color: #ef4444;
}

.status-badge.up {
  color: #10b981;
}

.info-modal-msg {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
  font-size: 13px;
  font-style: italic;
}

.info-selection-summary {
  background: #f8fafc;
  padding: 10px 20px;
  font-size: 11px;
  color: #475569;
  border-bottom: 1px solid #e2e8f0;
}

.info-tabs-nav {
  display: flex;
  background: #ffffff;
  border-bottom: 2px solid #f1f5f9;
}

.info-tab-item {
  flex: 1 1;
  padding: 10px;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}

.info-tab-item.active {
  color: #2563eb;
  background: #eff6ff;
}

.info-tab-item.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: #2563eb;
}

.info-actions-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  padding: 20px;
}

.btn-action-blue {
  background: #2563eb;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.btn-action-blue:hover {
  background: #1d4ed8;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.btn-action-blue:active {
  transform: translateY(0);
}


.ev-btn {
  padding: 3px 9px;
  border-radius: 4px;
  font-size: 9px;
  cursor: pointer;
  font-weight: 500;
  border: 1px solid;
  white-space: nowrap
}

.ev-btn-b {
  background: var(--bl5);
  color: #1e40af;
  border-color: #93c5fd
}

.ev-btn-r {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5
}

.ev-body {
  height: 400px;
  display: flex !important;
  flex-direction: column;
  background: var(--wh);
  overflow: hidden !important;
}

.ev-toolbar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 12px;
  border-bottom: 1px solid var(--b1);
  background: var(--bg2);
  flex-shrink: 0
}

.ev-search {
  display: flex;
  align-items: center;
  gap: 5px;
  background: var(--wh);
  border: 1px solid var(--b1);
  border-radius: 5px;
  padding: 3px 8px;
  flex: 1 1;
  max-width: 200px
}

.ev-search input {
  border: none;
  outline: none;
  font-size: 10px;
  color: var(--txt2);
  width: 100%;
  background: transparent
}

.ev-search input::placeholder {
  color: var(--txt4)
}

.ev-filter-sel {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  background: var(--wh);
  border: 1px solid var(--b1);
  border-radius: 5px;
  font-size: 10px;
  color: var(--txt2);
  padding: 3px 8px;
  outline: none;
  white-space: nowrap;
  transition: border-color 0.2s;
}

.ev-filter-sel:hover {
  border-color: var(--bl);
}

.ev-table-wrap {
  flex: 1 1;
  overflow: auto;
  background: var(--wh);
  position: relative;
}

.ev-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 10px;
}

.ev-table-thead {
  position: sticky;
  top: 0;
  z-index: 20;
  background: #f3f4f6;
}

.ev-table-thead th {
  text-align: left;
  padding: 8px 10px;
  color: #6b7280;
  font-weight: 600;
  text-transform: uppercase;
  border-bottom: 1px solid #e5e7eb;
  letter-spacing: 0.025em;
  white-space: nowrap;
}

.ev-table-row {
  transition: background 0.2s, box-shadow 0.2s;
  cursor: pointer;
  background: var(--wh);
}

.ev-table-row:hover {
  background: #f9fafb !important;
  box-shadow: inset 2px 0 0 var(--bl);
}

.ev-table-row td {
  padding: 8px 10px;
  border-bottom: 1px solid #f3f4f6;
  vertical-align: middle;
  color: #4b5563;
}

/* Futuristic Sev Badges */
.sev-pill {
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 700;
  font-size: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  border: 1px solid transparent;
  text-transform: uppercase;
}

.sev-pill.s5 {
  background: #fee2e2;
  color: #991b1b;
  border-color: #fca5a5;
  box-shadow: 0 0 8px rgba(239, 68, 68, 0.1);
}

.sev-pill.s4 {
  background: #fef3c7;
  color: #92400e;
  border-color: #a99959;
  box-shadow: 0 0 8px rgba(245, 158, 11, 0.1);
}

.sev-pill.s3 {
  background: #fff7ed;
  color: #9a3412;
  border-color: #ca955c;
}

.sev-pill.s2 {
  background: #ede9fe;
  color: #5b21b6;
  border-color: #c4b5fd;
}

.sev-pill.s1 {
  background: #e8f0fe;
  color: #1e40af;
  border-color: #93c5fd;
}

/* Status LED */
.status-led {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 6px;
}

.status-pill {
  padding: 2px 10px;
  border-radius: 20px;
  font-weight: 700;
  font-size: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  border: 1px solid;
  min-width: 70px;
}

.status-pill.resolved {
  background-color: #f0fdf4;
  color: #166534;
  border-color: #bbf7d0;
}

.status-pill.problem {
  background-color: #fef2f2;
  color: #b91c1c;
  border-color: #fecaca;
}

@keyframes pulse-red {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }

  100% {
    opacity: 1;
  }
}

.txt-futuristic {
  font-family: 'Inter', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  letter-spacing: -0.01em;
}

.ev-link {
  color: var(--bl);
  font-weight: 500;
  text-decoration: none;
}

.ev-link:hover {
  text-decoration: underline;
}

/* ACK Indicator */
.ack-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  margin: 0 auto;
}

.ack-dot.active {
  background: #3b82f6;
  border-color: #1d4ed8;
  box-shadow: 0 0 4px rgba(59, 130, 246, 0.6);
}

/* Custom Paginador Styles for ev-footer */
.ev-footer {
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  color: #6b7280;
  height: 10%;
}

.pag-btn-group {
  display: flex;
  gap: 4px;
}

.pag-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  background: var(--wh);
  border: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.2s;
}

.pag-btn:hover {
  border-color: var(--bl);
  color: var(--bl);
}

.pag-btn.active {
  background: var(--bl);
  color: var(--wh);
  border-color: var(--bl);
}

.pag-select {
  padding: 2px 4px;
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  font-size: 10px;
  outline: none;
  background: var(--wh);
}

.pag-select:focus {
  border-color: var(--bl);
}

.evtbl {
  width: 100%;
  border-collapse: collapse;
  font-size: 9px;
  table-layout: fixed
}

.evtbl th {
  color: var(--txt3);
  padding: 4px 8px;
  text-align: left;
  font-weight: 500;
  font-size: 8px;
  text-transform: uppercase;
  letter-spacing: .05em;
  background: var(--bg2);
  border-bottom: 1px solid var(--b1);
  white-space: nowrap;
  position: sticky;
  top: 0
}

.evtbl td {
  padding: 5px 8px;
  border-bottom: 1px solid var(--bg2);
  color: var(--txt2);
  vertical-align: middle;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap
}

.evtbl tr:last-child td {
  border-bottom: none
}

.evtbl tr.ev-row {
  cursor: pointer
}

.evtbl tr.ev-row:hover td {
  background: #f0f5ff
}

.evtbl tr.ev-row.selected td {
  background: #e8f0fe
}

.prob {
  color: var(--red);
  font-size: 8px;
  font-weight: 500
}

.dname {
  color: var(--bl);
  font-size: 8px
}

.tcell {
  color: var(--amb);
  font-size: 8px
}

.ev-detail {
  border-top: 1px solid var(--b1);
  background: var(--wh);
  display: none;
  flex-shrink: 0
}

.ev-detail.visible {
  display: block
}

.ev-detail-inner {
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 0
}

.ev-detail-info {
  padding: 10px 14px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px 20px;
  border-right: 1px solid var(--b1)
}

.ev-field-lbl {
  font-size: 8px;
  font-weight: 500;
  color: var(--txt3);
  text-transform: uppercase;
  letter-spacing: .07em;
  margin-bottom: 2px
}

.ev-field-val {
  font-size: 11px;
  font-weight: 500;
  color: var(--txt)
}

.ev-actions-panel {
  padding: 10px 14px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0;
  min-width: 260px
}

.ev-actions-lbl {
  font-size: 8px;
  font-weight: 500;
  color: var(--txt3);
  text-transform: uppercase;
  letter-spacing: .07em;
  margin-bottom: 7px
}

.ev-action-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 5px;
  margin-bottom: 5px
}

.ev-action-grid2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 5px
}

.act-btn {
  background: var(--bl);
  border: none;
  border-radius: 5px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  padding: 7px 6px;
  cursor: pointer;
  text-align: center
}

.act-btn:hover {
  background: #1648c0
}

.ev-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  border-top: 1px solid var(--b1);
  background: var(--bg2);
  flex-shrink: 0
}

.ev-pag {
  display: flex;
  align-items: center;
  gap: 4px
}

.pag-btn {
  width: 22px;
  height: 22px;
  border-radius: 4px;
  border: 1px solid var(--b1);
  background: var(--wh);
  font-size: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--txt3)
}

.pag-btn.active {
  background: var(--bl);
  color: #fff;
  border-color: var(--bl)
}

.ev-rows {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 9px;
  color: var(--txt3)
}

.ev-rows select {
  font-size: 9px;
  padding: 2px 4px;
  border: 1px solid var(--b1);
  border-radius: 4px;
  color: var(--txt2);
  background: var(--wh);
  outline: none
}

.ev-total {
  font-size: 9px;
  color: var(--txt3)
}

/* ══════════════════════════════
   MODAL DISPOSITIVO
══════════════════════════════ */
.modal-overlay {
  position: absolute;
  inset: 0;
  background: rgba(15, 45, 94, 0.45);
  z-index: 50;
  display: none;
  align-items: center;
  justify-content: center
}

.modal-overlay.visible {
  display: flex
}

.modal {
  background: var(--wh);
  border-radius: 10px;
  width: 90%;
  max-width: 680px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, .22);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 82%
}

/* Modal header */
.modal-header {
  background: var(--wh);
  padding: 12px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--b1);
  flex-shrink: 0
}

.modal-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--txt);
  text-align: center;
  flex: 1 1
}

.modal-close {
  width: 26px;
  height: 26px;
  border-radius: 6px;
  border: 1px solid var(--b1);
  background: var(--bg2);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--txt3);
  flex-shrink: 0
}

.modal-close:hover {
  background: var(--b1)
}

/* Tabla de hosts */
.modal-body {
  padding: 14px 18px;
  flex: 1 1;
  overflow-y: auto
}

.host-table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid var(--b1)
}

.host-table thead tr {
  background: var(--bl-dark)
}

.host-table th {
  padding: 8px 12px;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  text-align: center;
  letter-spacing: .04em
}

.host-table th:first-child {
  text-align: left
}

.host-table td {
  padding: 7px 12px;
  font-size: 11px;
  color: var(--txt2);
  text-align: center;
  border-bottom: 1px solid var(--bg2)
}

.host-table tr:last-child td {
  border-bottom: none
}

.host-table td:first-child {
  text-align: left
}

.host-sel {
  display: flex;
  align-items: center;
  gap: 6px
}

.host-sel-input {
  flex: 1 1;
  border: 1px solid var(--b1);
  border-radius: 5px;
  padding: 4px 8px;
  font-size: 11px;
  color: var(--txt2);
  outline: none;
  background: var(--wh)
}

.host-dropdown {
  width: 28px;
  height: 28px;
  border: 1px solid var(--b1);
  border-radius: 5px;
  background: var(--wh);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0
}

.status-exc {
  color: var(--pur);
  font-weight: 500;
  font-size: 11px
}

.status-ok {
  color: var(--gr);
  font-weight: 500;
  font-size: 11px
}

.status-down {
  color: var(--red);
  font-weight: 500;
  font-size: 11px
}

/* Sin relación */
.no-rel {
  padding: 28px;
  text-align: center;
  color: var(--txt4);
  font-size: 12px
}

/* Modal footer tabs */
.modal-footer {
  border-top: 1px solid var(--b1);
  flex-shrink: 0
}

.modal-dev-bar {
  padding: 8px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid var(--b1);
  background: var(--bg2)
}

.modal-dev-id {
  font-size: 10px;
  color: var(--txt2)
}

.modal-dev-id span {
  font-weight: 500;
  color: var(--txt)
}

.modal-tabs {
  display: flex
}

.modal-tab {
  flex: 1 1;
  padding: 9px 0;
  text-align: center;
  font-size: 11px;
  font-weight: 500;
  color: var(--txt3);
  cursor: pointer;
  border-right: 1px solid var(--b1);
  border-bottom: 2px solid transparent
}

.modal-tab:last-child {
  border-right: none
}

.modal-tab:hover {
  background: var(--bg2)
}

.modal-tab.active {
  color: var(--bl);
  background: var(--bl5);
  border-bottom: 2px solid var(--bl)
}

.modal-tab-content {
  padding: 14px 18px;
  min-height: 80px;
  display: none;
}

.modal-tab-content.active {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px
}

.act-btn-modal {
  background: var(--bl);
  border: none;
  border-radius: 6px;
  color: #fff;
  font-size: 11px;
  font-weight: 500;
  padding: 9px 6px;
  cursor: pointer;
  text-align: center
}

.act-btn-modal:hover {
  background: #1648c0
}

.modal-tab-content.alarmas {
  display: none;
  padding: 14px 18px
}

.modal-tab-content.alarmas.active {
  display: block
}

.modal-tab-content.salud {
  display: none;
  padding: 14px 18px
}

.modal-tab-content.salud.active {
  display: block
}

.empty-tab {
  text-align: center;
  color: var(--txt4);
  font-size: 12px;
  padding: 18px 0
}

/* ACTION MODAL PREMIUM */
.action-modal-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #1e293b;
}

.action-modal-header {
  padding: 16px 20px;
  background: var(--third-color);
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.action-modal-header h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.action-modal-close {
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.2s;
}

.action-modal-close:hover {
  opacity: 1;
}

.action-modal-body {
  padding: 30px;
  flex: 1 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: #f8fafc;
}

.action-prompt {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}

.action-icon-circle {
  width: 64px;
  height: 64px;
  background: #eff6ff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border: 1px solid #dbeafe;
}

.action-ip-badge {
  background: #1e293b;
  color: #f1f5f9;
  padding: 4px 12px;
  border-radius: 20px;
  font-family: monospace;
  font-size: 12px;
  font-weight: 600;
}

.action-loading-state {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.action-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e2e8f0;
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: spin-action 0.8s linear infinite;
}

@keyframes spin-action {
  to {
    transform: rotate(360deg);
  }
}

.action-result-container {
  width: 100%;
}

.action-result-banner {
  padding: 12px;
  border-radius: 8px;
  text-align: center;
  font-weight: 700;
  font-size: 14px;
  margin-bottom: 20px;
}

.action-result-banner.success {
  background: #dcfce7;
  color: #15803d;
  border: 1px solid #bbf7d0;
}

.action-result-banner.error {
  background: #fee2e2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.action-details-box {
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.action-detail-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.action-detail-item.terminal {
  flex: 1 1;
}

.action-detail-item .label {
  font-size: 10px;
  font-weight: 700;
  color: #94a3b8;
  text-transform: uppercase;
}

.action-detail-item .value {
  font-size: 13px;
  font-weight: 600;
}

.value-terminal {
  background: #0f172a;
  color: #38bdf8;
  padding: 12px;
  border-radius: 6px;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 12px;
  white-space: pre-wrap;
  max-height: 150px;
  overflow-y: auto;
  margin: 0;
}

.action-modal-footer {
  padding: 16px 20px;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.btn-action-cancel {
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-action-cancel:hover {
  background: #e2e8f0;
}

.btn-action-confirm {
  padding: 8px 20px;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  background: var(--third-color);
  border: none;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-action-confirm:hover {
  background: #002b82;
  transform: translateY(-1px);
}

/* MONITORING TABLES (ev-table) */
.ev-table-wrap {
  background: white;
  border-radius: 8px;
  overflow: auto;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.ev-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
}

.ev-table-thead th {
  position: sticky;
  top: 0;
  background: #f8fafc;
  padding: 10px 8px;
  text-align: left;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid #e2e8f0;
  z-index: 10;
}

.ev-table-tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.2s;
}

.ev-table-row:hover {
  background: #f8fafc;
  cursor: pointer;
}

.ev-table-tbody td {
  padding: 8px;
  vertical-align: middle;
  color: #334155;
}

.txt-futuristic {
  font-family: 'Outfit', sans-serif !important;
  letter-spacing: 0.02em;
}

.ev-link {
  color: #2563eb;
  font-weight: 600;
  text-decoration: none;
}

.ev-link:hover {
  text-decoration: underline;
}

/* SEVERITY PILLS */
.sev-pill {
  padding: 2px 6px;
  border-radius: 4px;
  font-weight: 800;
  font-size: 9px;
  text-align: center;
  color: white !important;
  display: inline-block;
  min-width: 32px;
}

.sev-pill.s1 {
  background: #10b981 !important;
}

.sev-pill.s2 {
  background: #3b82f6 !important;
}

.sev-pill.s3 {
  background: #f59e0b !important;
}

.sev-pill.s4 {
  background: #f97316 !important;
}

.sev-pill.s5 {
  background: #ef4444 !important;
}

.sev-pill.s6 {
  background: #8b5cf6 !important;
}

.sev-pill.s0 {
  background: #94a3b8 !important;
}

.status-pill {
  padding: 2px 8px;
  border-radius: 12px;
  font-size: 9px;
  font-weight: 700;
  text-transform: uppercase;
}

.status-pill.problem {
  background: #fee2e2;
  color: #b91c1c;
}

.status-pill.resolved {
  background: #dcfce7;
  color: #15803d;
}

.ack-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e2e8f0;
  margin: 0 auto;
}

.ack-dot.active {
  background: #2563eb;
  box-shadow: 0 0 8px rgba(37, 99, 235, 0.4);
}

/* STAT BAR NEW VARIABLES */
:root {
  --stat-up: #057a55;
  --stat-unk: #64748b;
  --stat-dwn: #db2777;
  /* ROSA */
  --stat-odd: #e02424;
  /* ROJO */
  --stat-exc: #d97706;
}

.stat-bar-new {
  background: rgba(255, 255, 255, 0.97);
  border-bottom: 1px solid #e2e8f0;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  z-index: 10;
}

.stat-total-card {
  display: flex;
  flex-direction: column;
  padding: 5px 12px;
  min-width: 80px;
}

.stat-total-num {
  font-size: 28px;
  font-weight: 700;
  color: #0f172a;
  font-family: 'DM Mono', monospace;
  line-height: 1;
}

.stat-total-lbl {
  font-size: 9px;
  font-weight: 500;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: .06em;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: #e2e8f0;
  margin: 0 8px;
}

.stat-card {
  display: flex;
  align-items: center;
  gap: 10px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 7px 12px;
  min-width: 60px;
  position: relative;
  transition: all 0.2s ease;
}

.stat-card:hover {
  border-color: #cbd5e1;
  transform: translateY(-1px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}

.stat-card::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  border-radius: 8px 0 0 8px;
}

/* Modifier classes for cards */
.stat-card.up::before {
  background: var(--stat-up);
}

.stat-card.unk::before {
  background: var(--stat-unk);
}

.stat-card.down::before {
  background: var(--stat-dwn);
}

.stat-card.odd::before {
  background: var(--stat-odd);
}

.stat-card.exc::before {
  background: var(--stat-exc);
}

.stat-card-info {
  display: flex;
  flex-direction: column;
}

.stat-card-lbl {
  font-size: 9px;
  font-weight: 600;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: .07em;
  line-height: 1;
  margin-bottom: 2px;
}

.stat-card-num {
  font-size: 22px;
  font-weight: 600;
  font-family: 'DM Mono', monospace;
  line-height: 1;
}

.stat-card-sub {
  font-size: 8px;
  color: #64748b;
  margin-top: 1px;
}

/* Colors for numbers */
.stat-card.up .stat-card-num {
  color: var(--stat-up);
}

.stat-card.unk .stat-card-num {
  color: var(--stat-unk);
}

.stat-card.down .stat-card-num {
  color: var(--stat-dwn);
}

.stat-card.odd .stat-card-num {
  color: var(--stat-odd);
}

.stat-card.exc .stat-card-num {
  color: var(--stat-exc);
}

.stat-card-dot-wrap {
  margin-left: auto;
  display: flex;
  align-items: center;
}

.stat-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

/* Dot variants */
.stat-card.up .stat-dot {
  background: var(--stat-up);
  box-shadow: 0 0 0 3px rgba(5, 122, 85, .12);
}

.stat-card.unk .stat-dot {
  background: var(--stat-unk);
  box-shadow: 0 0 0 3px rgba(100, 116, 139, .12);
}

.stat-card.down .stat-dot {
  background: var(--stat-dwn);
  box-shadow: 0 0 0 3px rgba(219, 39, 119, .12);
}

.stat-card.odd .stat-dot {
  background: var(--stat-odd);
  box-shadow: 0 0 0 3px rgba(224, 36, 36, .12);
}

.stat-card.exc .stat-dot {
  background: var(--stat-exc);
  box-shadow: 0 0 0 3px rgba(217, 119, 6, .12);
}

/* TOOLTIP STYLES */
.stat-tooltip {
  visibility: hidden;
  opacity: 0;
  position: absolute;
  top: 105%;
  left: 0;
  background: white;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  z-index: 1000;
  width: 320px;
  min-height: 100px;
  max-height: 450px;
  overflow-y: auto;
  transition: all 0.2s ease;
  pointer-events: none;
}

.stat-card:hover .stat-tooltip {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(5px);
}`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/devicesMap/MapStyles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;EACd,cAAc;EACd,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;EACf,aAAa;EACb,aAAa;EACb,cAAc;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,2BAA2B;EAC3B;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;EACnB;AACF;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,8BAA8B;EAC9B;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX;gCAC8B;EAC9B,YAAY;EACZ,oCAAoC;EACpC,mCAA2B;UAA3B,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,mFAAmF;EACnF,qCAAqC;EACrC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,sBAAsB;EACtB,SAAS;EACT,4CAA4C;EAC5C,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,iDAAiD;EACjD,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,kDAAkD;EAClD,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;AAC3D;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB;AACF;;AAEA;EACE,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAgB;UAAhB;AACF;;AAEA;EACE,0BAA0B;EAC1B;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,QAAQ;EACR;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,yCAAyC;EACzC,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,YAAY;EACZ,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,kCAAkC;EAClC;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,eAAe;EACf,eAAe;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;AACF;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB;AACF;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,WAAW;EACX,oCAAoC;EACpC,+BAA+B;EAC/B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB;AACF;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,oBAAoB;EACpB,iFAAiF;AACnF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,iBAAiB;EACjB,mBAAmB;EACnB,yDAAyD;EACzD,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,kCAA0B;UAA1B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kDAAkD;EAClD,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,kDAAkD;EAClD,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB;AACF;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;AACF;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,sBAAsB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,SAAO;EACP;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,4CAA4C;EAC5C,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,mCAAmC;AACrC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;EACtB,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,sFAAsF;EACtF,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,0CAA0C;AAC1C;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,cAAc;EACd;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,sBAAsB;EACtB,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB;AACF;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,MAAM;EACN;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB;AACF;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,QAAQ;EACR;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B;AACF;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,+BAA+B;EAC/B,sBAAsB;EACtB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd;AACF;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;;gCAEgC;AAChC;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB;AACF;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,SAAO;EACP;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB;AACF;;AAEA;EACE,SAAO;EACP,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB;AACF;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB;AACF;;AAEA,sBAAsB;AACtB;EACE,+BAA+B;EAC/B;AACF;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kCAAkC;EAClC;AACF;;AAEA;EACE,eAAe;EACf;AACF;;AAEA;EACE,gBAAgB;EAChB;AACF;;AAEA;EACE;AACF;;AAEA;EACE,SAAO;EACP,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB;AACF;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC;AACF;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,aAAa;EACb;AACF;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf;AACF;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,4CAA4C;EAC5C,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,iCAAiC;AACjC;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,4CAA4C;EAC5C,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,qFAAqF;EACrF,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,0BAA0B;AAC5B","sourcesContent":[":root {\n  --bl: #1a56db;\n  --bl-dark: #0f2d5e;\n  --bl5: #e8f0fe;\n  --gr: #057a55;\n  --red: #e02424;\n  --amb: #d97706;\n  --pur: #7e3af2;\n  --txt: #111827;\n  --txt2: #374151;\n  --txt3: #6b7280;\n  --txt4: #9ca3af;\n  --b1: #e5e7eb;\n  --b2: #d1d5db;\n  --bg2: #f3f4f6;\n  --wh: #fff\n}\n\n.shell {\n  position: relative;\n  height: 99%;\n  width: 100%;\n  /* border-radius: 10px; */\n  overflow: hidden;\n  border: 1px solid var(--b1);\n  box-shadow: 0 1px 4px rgba(0, 0, 0, .07)\n}\n\n.map-full {\n  position: absolute;\n  inset: 0;\n  background: #eef2f7;\n  z-index: 0\n}\n\n/* TOPBAR */\n.topbar {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10;\n  background: var(--bl-dark);\n  padding: 7px 14px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between\n}\n\n.tb-brand {\n  display: flex;\n  align-items: center;\n  gap: 8px\n}\n\n.tb-logo {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, .18);\n  display: flex;\n  align-items: center;\n  justify-content: center\n}\n\n.tb-name {\n  font-size: 13px;\n  font-weight: 500;\n  color: #fff\n}\n\n.tb-sep {\n  color: rgba(255, 255, 255, .3);\n  margin: 0 2px\n}\n\n.tb-sub {\n  font-size: 10px;\n  color: rgba(255, 255, 255, .6)\n}\n\n.tb-pill {\n  background: rgba(255, 255, 255, .12);\n  border: 0.5px solid rgba(255, 255, 255, .2);\n  border-radius: 4px;\n  padding: 2px 8px;\n  font-size: 10px;\n  color: rgba(255, 255, 255, .85)\n}\n\n/* STATBAR MODERNIZED */\n.statbar {\n  position: absolute;\n  top: 0px;\n  width: 100%;\n  /* left: 50%;\n  transform: translateX(-50%); */\n  z-index: 100;\n  background: rgba(255, 255, 255, 0.9);\n  backdrop-filter: blur(12px);\n  padding: 8px 24px;\n  display: flex;\n  gap: 15px;\n  align-items: center;\n  /* border-radius: 50px; */\n  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1);\n  border: 1px solid var(--second-color);\n  white-space: nowrap;\n}\n\n.stg {\n  position: relative;\n  display: flex;\n  align-items: center;\n  /* gap: 8px; */\n}\n\n.stg-lbl {\n  color: #64748b;\n  font-size: 11px;\n  text-transform: uppercase;\n  letter-spacing: .05em;\n  font-weight: 800;\n}\n\n.pill {\n  border-radius: 8px;\n  padding: 4px 12px;\n  font-size: 14px;\n  font-weight: 800;\n  min-width: 30px;\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.pill:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.p-up {\n  background: #dcfce7;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n}\n\n.p-dn {\n  background: #fee2e2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.p-uk {\n  background: #f1f5f9;\n  color: #475569;\n  border: 1px solid #e2e8f0;\n}\n\n.p-odd {\n  background: #f3e8ff;\n  color: #7e22ce;\n  border: 1px solid #e9d5ff;\n}\n\n.p-ex {\n  background: #fef3c7;\n  color: #b45309;\n  border: 1px solid #fde68a;\n}\n\n/* Counter Hover Tooltip */\n.stg-tooltip {\n  position: absolute;\n  top: calc(100% + 12px);\n  left: 50%;\n  transform: translateX(-50%) translateY(10px);\n  width: 340px;\n  background: #ffffff;\n  border-radius: 16px;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);\n  padding: 0;\n  visibility: hidden;\n  opacity: 0;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  z-index: 1000;\n  pointer-events: none;\n  border: 1px solid #f1f5f9;\n  overflow: hidden;\n}\n\n.stg:hover .stg-tooltip {\n  visibility: visible;\n  opacity: 1;\n  transform: translateX(-50%) translateY(0);\n}\n\n.stg-tooltip::after {\n  content: '';\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 8px;\n  border-style: solid;\n  border-color: transparent transparent #ffffff transparent;\n}\n\n/* FILTROS + CAPAS */\n.top-left-row {\n  position: absolute;\n  top: 80px;\n  left: 10px;\n  z-index: 8;\n  display: flex;\n  align-items: flex-start;\n  gap: 8px\n}\n\n.panel-filtros {\n  width: 210px;\n  background: rgba(255, 255, 255, .97);\n  border: 1px solid var(--b1);\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, .12)\n}\n\n.panel-hdr {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 7px 10px;\n  cursor: pointer;\n  border-radius: 8px;\n  user-select: none\n}\n\n.panel-hdr.expanded {\n  border-radius: 8px 8px 0 0;\n  border-bottom: 1px solid var(--b1)\n}\n\n.panel-hdr:hover {\n  background: var(--bg2)\n}\n\n.panel-hdr-left {\n  display: flex;\n  align-items: center;\n  gap: 7px\n}\n\n.panel-hdr-txt {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--txt2)\n}\n\n.chev {\n  color: var(--txt3);\n  display: flex;\n  align-items: center;\n  transition: transform .18s\n}\n\n.chev.open {\n  transform: rotate(180deg)\n}\n\n.panel-body {\n  padding: 9px 10px;\n  display: flex;\n  flex-direction: column;\n  gap: 7px\n}\n\n.panel-body.hidden {\n  display: none\n}\n\n.f-lbl {\n  font-size: 9px;\n  color: var(--txt3);\n  text-transform: uppercase;\n  letter-spacing: .06em;\n  margin-bottom: 2px\n}\n\n.f-sel {\n  width: 100%;\n  border: 1px solid var(--b1);\n  border-radius: 4px;\n  color: var(--txt2);\n  font-size: 10px;\n  padding: 3px 5px;\n  background: var(--wh);\n  outline: none\n}\n\n.f-inp {\n  width: 100%;\n  border: 1px solid var(--b1);\n  border-radius: 4px;\n  color: var(--txt2);\n  font-size: 10px;\n  padding: 3px 5px;\n  background: var(--wh);\n  outline: none\n}\n\n.f-inp::placeholder {\n  color: var(--txt4)\n}\n\n.sbts {\n  display: flex;\n  gap: 3px;\n  flex-wrap: wrap\n}\n\n.sbt {\n  border-radius: 4px;\n  padding: 2px 6px;\n  font-size: 9px;\n  cursor: pointer;\n  border: 1px solid;\n  font-weight: 500\n}\n\n.sbt-g {\n  background: #d1fae5;\n  color: #065f46;\n  border-color: #a7f3d0\n}\n\n.sbt-r {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5\n}\n\n.sbt-u {\n  background: var(--bg2);\n  color: var(--txt3);\n  border-color: var(--b2)\n}\n\n.sbt-a {\n  background: #fef3c7;\n  color: #92400e;\n  border-color: #fde68a\n}\n\n.sbt-p {\n  background: #ede9fe;\n  color: #5b21b6;\n  border-color: #c4b5fd\n}\n\n.btn-capas {\n  background: rgba(255, 255, 255, .97);\n  border: 1px solid var(--b1);\n  border-radius: 8px;\n  padding: 7px 14px;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--bl);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, .12);\n  white-space: nowrap;\n  height: 34px\n}\n\n.btn-capas:hover {\n  background: var(--bl5)\n}\n\n.panel-capas {\n  position: absolute;\n  top: 42px;\n  left: 0;\n  width: 195px;\n  background: rgba(255, 255, 255, .97);\n  border: 1px solid var(--b1);\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, .12);\n  display: none;\n  z-index: 22\n}\n\n.panel-capas.visible {\n  display: block\n}\n\n.capas-title {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--txt2);\n  text-align: center;\n  padding: 7px 10px;\n  border-bottom: 1px solid var(--b1);\n  border-radius: 8px 8px 0 0\n}\n\n.capas-item {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding: 7px 12px;\n  border-bottom: 1px solid var(--bg2);\n  cursor: pointer;\n  font-size: 11px;\n  color: var(--txt2)\n}\n\n.capas-item:last-child {\n  border-bottom: none;\n  border-radius: 0 0 8px 8px\n}\n\n.capas-item:hover {\n  background: var(--bg2)\n}\n\n.capas-cb {\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n  border: 1.5px solid var(--bl);\n  background: var(--bl5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0\n}\n\n/* LEYENDA */\n.panel-leyenda {\n  position: absolute;\n  bottom: 10px;\n  left: 10px;\n  z-index: 20;\n  background: rgba(255, 255, 255, .95);\n  border: 1px solid var(--b1);\n  border-radius: 8px;\n  padding: 8px 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, .1)\n}\n\n.leg-lbl {\n  font-size: 9px;\n  color: var(--txt3);\n  text-transform: uppercase;\n  letter-spacing: .06em;\n  margin-bottom: 4px\n}\n\n.leg-row {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 9px;\n  color: var(--txt3);\n  margin-bottom: 3px\n}\n\n.leg-row:last-child {\n  margin-bottom: 0\n}\n\n.dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  display: inline-block;\n  flex-shrink: 0\n}\n\n/* EVENTOS */\n.panel-eventos {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  background: rgba(255, 255, 255, .97);\n  border-top: 1px solid var(--b1);\n  box-shadow: 0 -4px 16px rgba(0, 0, 0, .1)\n}\n\n.ev-hdr {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 0 12px;\n  height: 36px;\n  cursor: pointer;\n  user-select: none;\n  background: var(--third-color);\n}\n\n.ev-hdr:hover {\n  background: rgba(0, 43, 130, 0.979);\n}\n\n.ev-hdr.has-border {\n  border-bottom: 1px solid var(--b1)\n}\n\n.ev-title {\n  font-size: 10px;\n  font-weight: 500;\n  color: var(--white-color);\n  text-transform: uppercase;\n  letter-spacing: .06em;\n  white-space: nowrap\n}\n\n.ev-cnt-pill {\n  padding: 1px 8px;\n  border-radius: 10px;\n  font-size: 9px;\n  font-weight: 700;\n  min-width: 24px;\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid transparent;\n}\n\n.ev-cnt-pill.total {\n  background: #e8f0fe;\n  color: #1a56db;\n  border-color: #c3dafe;\n}\n\n.ev-cnt-pill.problem {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n.ev-cnt-pill.resolved {\n  background: #ecfdf5;\n  color: #065f46;\n  border-color: #a7f3d0;\n}\n\n/* Severity Counter Split Style - Static & Distinct */\n.sev-counter {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 4px;\n  overflow: hidden;\n  font-size: 9px;\n  font-weight: 700;\n  border: 1px solid;\n  margin-right: 4px;\n  cursor: default;\n  /* transition: transform 0.1s; */\n}\n\n.sev-counter .label {\n  padding: 1px 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  filter: brightness(0.95);\n  /* Slightly darker */\n}\n\n.sev-counter .value {\n  padding: 1px 8px;\n  background: var(--wh);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sev-counter.sev5 {\n  border-color: #fca5a5;\n  color: #991b1b;\n}\n\n.sev-counter.sev5 .label {\n  background: #fee2e2;\n}\n\n.sev-counter.sev5 .value {\n  background: #fff5f5;\n}\n\n.sev-counter.sev4 {\n  border-color: #fde68a;\n  color: #92400e;\n}\n\n.sev-counter.sev4 .label {\n  background: #fef3c7;\n}\n\n.sev-counter.sev4 .value {\n  background: #fffdf2;\n}\n\n.sev-counter.sev3 {\n  border-color: #fdba74;\n  color: #9a3412;\n}\n\n.sev-counter.sev3 .label {\n  background: #fff7ed;\n}\n\n.sev-counter.sev3 .value {\n  background: #fffcf0;\n}\n\n.sev-counter.sev2 {\n  border-color: #c4b5fd;\n  color: #5b21b6;\n}\n\n.sev-counter.sev2 .label {\n  background: #ede9fe;\n}\n\n.sev-counter.sev2 .value {\n  background: #f5f3ff;\n}\n\n.sev-counter.sev1 {\n  border-color: #93c5fd;\n  color: #1e40af;\n}\n\n.sev-counter.sev1 .label {\n  background: #e8f0fe;\n}\n\n.sev-counter.sev1 .value {\n  background: #f0f7ff;\n}\n\n.ev-sev {\n  display: flex;\n  align-items: center;\n  gap: 4px\n}\n\n.sev-badge {\n  border-radius: 3px;\n  padding: 1px 5px;\n  font-size: 8px;\n  font-weight: 500;\n  border: 1px solid;\n  white-space: nowrap\n}\n\n.sev-sev5 {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5\n}\n\n.sev-sev4 {\n  background: #fef3c7;\n  color: #92400e;\n  border-color: #fde68a\n}\n\n.sev-sev2 {\n  background: #ede9fe;\n  color: #5b21b6;\n  border-color: #c4b5fd\n}\n\n.sev-sev1 {\n  background: #e8f0fe;\n  color: #1e40af;\n  border-color: #93c5fd\n}\n\n.ev-actions-bar {\n  margin-left: auto;\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  flex-shrink: 0\n}\n\n/* Custom Tooltip System */\n[data-tooltip] {\n  position: relative;\n}\n\n[data-tooltip]::before {\n  content: attr(data-tooltip);\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  padding: 4px 10px;\n  background: #1e293b;\n  color: #f8fafc;\n  font-size: 9px;\n  font-weight: 500;\n  border-radius: 4px;\n  white-space: nowrap;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease;\n  z-index: 1000;\n  pointer-events: none;\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n\n[data-tooltip]::after {\n  content: '';\n  position: absolute;\n  bottom: calc(100% + 3px);\n  left: 50%;\n  transform: translateX(-50%);\n  border-width: 5px;\n  border-style: solid;\n  border-color: #1e293b transparent transparent transparent;\n  opacity: 0;\n  visibility: hidden;\n  transition: all 0.2s ease;\n  z-index: 1000;\n  pointer-events: none;\n}\n\n[data-tooltip]:hover::before,\n[data-tooltip]:hover::after {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Info Marker Modal Modernized */\n.info-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 2000;\n}\n\n.info-modal-content {\n  background: var(--wh);\n  width: 80%;\n  height: 80%;\n  border-radius: 12px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.info-modal-hdr {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 5px 20px;\n  border-bottom: 1px solid #f1f5f9;\n  position: relative;\n}\n\n.info-modal-hdr h2 {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--third-color);\n  margin: 0;\n}\n\n.info-modal-close {\n  position: absolute;\n  right: 16px;\n  top: 14px;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: #f1f5f9;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.info-modal-close:hover {\n  background: #fee2e2;\n  color: #ef4444;\n}\n\n.info-device-bar {\n  background: #1e3a8a;\n  color: #ffffff;\n  display: grid;\n  grid-template-columns: 1.5fr 1fr 0.8fr 0.8fr 0.8fr;\n  padding: 10px 20px;\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.025em;\n}\n\n.info-device-row {\n  display: grid;\n  grid-template-columns: 1.5fr 1fr 0.8fr 0.8fr 0.8fr;\n  padding: 12px 20px;\n  align-items: center;\n  font-size: 12px;\n  color: #334155;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.info-device-sel-container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.info-device-sel {\n  padding: 6px 12px;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  background: #ffffff;\n  font-size: 12px;\n  color: #1e293b;\n  width: 100%;\n  outline: none;\n}\n\n.status-badge {\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.status-badge.down {\n  color: #ef4444;\n}\n\n.status-badge.up {\n  color: #10b981;\n}\n\n.info-modal-msg {\n  text-align: center;\n  padding: 20px;\n  color: #94a3b8;\n  font-size: 13px;\n  font-style: italic;\n}\n\n.info-selection-summary {\n  background: #f8fafc;\n  padding: 10px 20px;\n  font-size: 11px;\n  color: #475569;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.info-tabs-nav {\n  display: flex;\n  background: #ffffff;\n  border-bottom: 2px solid #f1f5f9;\n}\n\n.info-tab-item {\n  flex: 1;\n  padding: 10px;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n}\n\n.info-tab-item.active {\n  color: #2563eb;\n  background: #eff6ff;\n}\n\n.info-tab-item.active::after {\n  content: '';\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: #2563eb;\n}\n\n.info-actions-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n  padding: 20px;\n}\n\n.btn-action-blue {\n  background: #2563eb;\n  color: #ffffff;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  text-align: center;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.btn-action-blue:hover {\n  background: #1d4ed8;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.btn-action-blue:active {\n  transform: translateY(0);\n}\n\n\n.ev-btn {\n  padding: 3px 9px;\n  border-radius: 4px;\n  font-size: 9px;\n  cursor: pointer;\n  font-weight: 500;\n  border: 1px solid;\n  white-space: nowrap\n}\n\n.ev-btn-b {\n  background: var(--bl5);\n  color: #1e40af;\n  border-color: #93c5fd\n}\n\n.ev-btn-r {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5\n}\n\n.ev-body {\n  height: 400px;\n  display: flex !important;\n  flex-direction: column;\n  background: var(--wh);\n  overflow: hidden !important;\n}\n\n.ev-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 5px 12px;\n  border-bottom: 1px solid var(--b1);\n  background: var(--bg2);\n  flex-shrink: 0\n}\n\n.ev-search {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  background: var(--wh);\n  border: 1px solid var(--b1);\n  border-radius: 5px;\n  padding: 3px 8px;\n  flex: 1;\n  max-width: 200px\n}\n\n.ev-search input {\n  border: none;\n  outline: none;\n  font-size: 10px;\n  color: var(--txt2);\n  width: 100%;\n  background: transparent\n}\n\n.ev-search input::placeholder {\n  color: var(--txt4)\n}\n\n.ev-filter-sel {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  cursor: pointer;\n  background: var(--wh);\n  border: 1px solid var(--b1);\n  border-radius: 5px;\n  font-size: 10px;\n  color: var(--txt2);\n  padding: 3px 8px;\n  outline: none;\n  white-space: nowrap;\n  transition: border-color 0.2s;\n}\n\n.ev-filter-sel:hover {\n  border-color: var(--bl);\n}\n\n.ev-table-wrap {\n  flex: 1;\n  overflow: auto;\n  background: var(--wh);\n  position: relative;\n}\n\n.ev-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 10px;\n}\n\n.ev-table-thead {\n  position: sticky;\n  top: 0;\n  z-index: 20;\n  background: #f3f4f6;\n}\n\n.ev-table-thead th {\n  text-align: left;\n  padding: 8px 10px;\n  color: #6b7280;\n  font-weight: 600;\n  text-transform: uppercase;\n  border-bottom: 1px solid #e5e7eb;\n  letter-spacing: 0.025em;\n  white-space: nowrap;\n}\n\n.ev-table-row {\n  transition: background 0.2s, box-shadow 0.2s;\n  cursor: pointer;\n  background: var(--wh);\n}\n\n.ev-table-row:hover {\n  background: #f9fafb !important;\n  box-shadow: inset 2px 0 0 var(--bl);\n}\n\n.ev-table-row td {\n  padding: 8px 10px;\n  border-bottom: 1px solid #f3f4f6;\n  vertical-align: middle;\n  color: #4b5563;\n}\n\n/* Futuristic Sev Badges */\n.sev-pill {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 700;\n  font-size: 9px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  border: 1px solid transparent;\n  text-transform: uppercase;\n}\n\n.sev-pill.s5 {\n  background: #fee2e2;\n  color: #991b1b;\n  border-color: #fca5a5;\n  box-shadow: 0 0 8px rgba(239, 68, 68, 0.1);\n}\n\n.sev-pill.s4 {\n  background: #fef3c7;\n  color: #92400e;\n  border-color: #a99959;\n  box-shadow: 0 0 8px rgba(245, 158, 11, 0.1);\n}\n\n.sev-pill.s3 {\n  background: #fff7ed;\n  color: #9a3412;\n  border-color: #ca955c;\n}\n\n.sev-pill.s2 {\n  background: #ede9fe;\n  color: #5b21b6;\n  border-color: #c4b5fd;\n}\n\n.sev-pill.s1 {\n  background: #e8f0fe;\n  color: #1e40af;\n  border-color: #93c5fd;\n}\n\n/* Status LED */\n.status-led {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 6px;\n}\n\n.status-pill {\n  padding: 2px 10px;\n  border-radius: 20px;\n  font-weight: 700;\n  font-size: 9px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  border: 1px solid;\n  min-width: 70px;\n}\n\n.status-pill.resolved {\n  background-color: #f0fdf4;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.status-pill.problem {\n  background-color: #fef2f2;\n  color: #b91c1c;\n  border-color: #fecaca;\n}\n\n@keyframes pulse-red {\n  0% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0.6;\n  }\n\n  100% {\n    opacity: 1;\n  }\n}\n\n.txt-futuristic {\n  font-family: 'Inter', ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;\n  letter-spacing: -0.01em;\n}\n\n.ev-link {\n  color: var(--bl);\n  font-weight: 500;\n  text-decoration: none;\n}\n\n.ev-link:hover {\n  text-decoration: underline;\n}\n\n/* ACK Indicator */\n.ack-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #f3f4f6;\n  border: 1px solid #d1d5db;\n  margin: 0 auto;\n}\n\n.ack-dot.active {\n  background: #3b82f6;\n  border-color: #1d4ed8;\n  box-shadow: 0 0 4px rgba(59, 130, 246, 0.6);\n}\n\n/* Custom Paginador Styles for ev-footer */\n.ev-footer {\n  background: #f9fafb;\n  border-top: 1px solid #e5e7eb;\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-size: 11px;\n  color: #6b7280;\n  height: 10%;\n}\n\n.pag-btn-group {\n  display: flex;\n  gap: 4px;\n}\n\n.pag-btn {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  background: var(--wh);\n  border: 1px solid #e5e7eb;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.pag-btn:hover {\n  border-color: var(--bl);\n  color: var(--bl);\n}\n\n.pag-btn.active {\n  background: var(--bl);\n  color: var(--wh);\n  border-color: var(--bl);\n}\n\n.pag-select {\n  padding: 2px 4px;\n  border: 1px solid #e5e7eb;\n  border-radius: 4px;\n  font-size: 10px;\n  outline: none;\n  background: var(--wh);\n}\n\n.pag-select:focus {\n  border-color: var(--bl);\n}\n\n.evtbl {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 9px;\n  table-layout: fixed\n}\n\n.evtbl th {\n  color: var(--txt3);\n  padding: 4px 8px;\n  text-align: left;\n  font-weight: 500;\n  font-size: 8px;\n  text-transform: uppercase;\n  letter-spacing: .05em;\n  background: var(--bg2);\n  border-bottom: 1px solid var(--b1);\n  white-space: nowrap;\n  position: sticky;\n  top: 0\n}\n\n.evtbl td {\n  padding: 5px 8px;\n  border-bottom: 1px solid var(--bg2);\n  color: var(--txt2);\n  vertical-align: middle;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap\n}\n\n.evtbl tr:last-child td {\n  border-bottom: none\n}\n\n.evtbl tr.ev-row {\n  cursor: pointer\n}\n\n.evtbl tr.ev-row:hover td {\n  background: #f0f5ff\n}\n\n.evtbl tr.ev-row.selected td {\n  background: #e8f0fe\n}\n\n.prob {\n  color: var(--red);\n  font-size: 8px;\n  font-weight: 500\n}\n\n.dname {\n  color: var(--bl);\n  font-size: 8px\n}\n\n.tcell {\n  color: var(--amb);\n  font-size: 8px\n}\n\n.ev-detail {\n  border-top: 1px solid var(--b1);\n  background: var(--wh);\n  display: none;\n  flex-shrink: 0\n}\n\n.ev-detail.visible {\n  display: block\n}\n\n.ev-detail-inner {\n  display: grid;\n  grid-template-columns: 1fr auto;\n  gap: 0\n}\n\n.ev-detail-info {\n  padding: 10px 14px;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px 20px;\n  border-right: 1px solid var(--b1)\n}\n\n.ev-field-lbl {\n  font-size: 8px;\n  font-weight: 500;\n  color: var(--txt3);\n  text-transform: uppercase;\n  letter-spacing: .07em;\n  margin-bottom: 2px\n}\n\n.ev-field-val {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--txt)\n}\n\n.ev-actions-panel {\n  padding: 10px 14px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  gap: 0;\n  min-width: 260px\n}\n\n.ev-actions-lbl {\n  font-size: 8px;\n  font-weight: 500;\n  color: var(--txt3);\n  text-transform: uppercase;\n  letter-spacing: .07em;\n  margin-bottom: 7px\n}\n\n.ev-action-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 5px;\n  margin-bottom: 5px\n}\n\n.ev-action-grid2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 5px\n}\n\n.act-btn {\n  background: var(--bl);\n  border: none;\n  border-radius: 5px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 500;\n  padding: 7px 6px;\n  cursor: pointer;\n  text-align: center\n}\n\n.act-btn:hover {\n  background: #1648c0\n}\n\n.ev-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 4px 12px;\n  border-top: 1px solid var(--b1);\n  background: var(--bg2);\n  flex-shrink: 0\n}\n\n.ev-pag {\n  display: flex;\n  align-items: center;\n  gap: 4px\n}\n\n.pag-btn {\n  width: 22px;\n  height: 22px;\n  border-radius: 4px;\n  border: 1px solid var(--b1);\n  background: var(--wh);\n  font-size: 10px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--txt3)\n}\n\n.pag-btn.active {\n  background: var(--bl);\n  color: #fff;\n  border-color: var(--bl)\n}\n\n.ev-rows {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  font-size: 9px;\n  color: var(--txt3)\n}\n\n.ev-rows select {\n  font-size: 9px;\n  padding: 2px 4px;\n  border: 1px solid var(--b1);\n  border-radius: 4px;\n  color: var(--txt2);\n  background: var(--wh);\n  outline: none\n}\n\n.ev-total {\n  font-size: 9px;\n  color: var(--txt3)\n}\n\n/* ══════════════════════════════\n   MODAL DISPOSITIVO\n══════════════════════════════ */\n.modal-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(15, 45, 94, 0.45);\n  z-index: 50;\n  display: none;\n  align-items: center;\n  justify-content: center\n}\n\n.modal-overlay.visible {\n  display: flex\n}\n\n.modal {\n  background: var(--wh);\n  border-radius: 10px;\n  width: 90%;\n  max-width: 680px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, .22);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  max-height: 82%\n}\n\n/* Modal header */\n.modal-header {\n  background: var(--wh);\n  padding: 12px 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--b1);\n  flex-shrink: 0\n}\n\n.modal-title {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--txt);\n  text-align: center;\n  flex: 1\n}\n\n.modal-close {\n  width: 26px;\n  height: 26px;\n  border-radius: 6px;\n  border: 1px solid var(--b1);\n  background: var(--bg2);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--txt3);\n  flex-shrink: 0\n}\n\n.modal-close:hover {\n  background: var(--b1)\n}\n\n/* Tabla de hosts */\n.modal-body {\n  padding: 14px 18px;\n  flex: 1;\n  overflow-y: auto\n}\n\n.host-table {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 6px;\n  overflow: hidden;\n  border: 1px solid var(--b1)\n}\n\n.host-table thead tr {\n  background: var(--bl-dark)\n}\n\n.host-table th {\n  padding: 8px 12px;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 500;\n  text-align: center;\n  letter-spacing: .04em\n}\n\n.host-table th:first-child {\n  text-align: left\n}\n\n.host-table td {\n  padding: 7px 12px;\n  font-size: 11px;\n  color: var(--txt2);\n  text-align: center;\n  border-bottom: 1px solid var(--bg2)\n}\n\n.host-table tr:last-child td {\n  border-bottom: none\n}\n\n.host-table td:first-child {\n  text-align: left\n}\n\n.host-sel {\n  display: flex;\n  align-items: center;\n  gap: 6px\n}\n\n.host-sel-input {\n  flex: 1;\n  border: 1px solid var(--b1);\n  border-radius: 5px;\n  padding: 4px 8px;\n  font-size: 11px;\n  color: var(--txt2);\n  outline: none;\n  background: var(--wh)\n}\n\n.host-dropdown {\n  width: 28px;\n  height: 28px;\n  border: 1px solid var(--b1);\n  border-radius: 5px;\n  background: var(--wh);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0\n}\n\n.status-exc {\n  color: var(--pur);\n  font-weight: 500;\n  font-size: 11px\n}\n\n.status-ok {\n  color: var(--gr);\n  font-weight: 500;\n  font-size: 11px\n}\n\n.status-down {\n  color: var(--red);\n  font-weight: 500;\n  font-size: 11px\n}\n\n/* Sin relación */\n.no-rel {\n  padding: 28px;\n  text-align: center;\n  color: var(--txt4);\n  font-size: 12px\n}\n\n/* Modal footer tabs */\n.modal-footer {\n  border-top: 1px solid var(--b1);\n  flex-shrink: 0\n}\n\n.modal-dev-bar {\n  padding: 8px 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid var(--b1);\n  background: var(--bg2)\n}\n\n.modal-dev-id {\n  font-size: 10px;\n  color: var(--txt2)\n}\n\n.modal-dev-id span {\n  font-weight: 500;\n  color: var(--txt)\n}\n\n.modal-tabs {\n  display: flex\n}\n\n.modal-tab {\n  flex: 1;\n  padding: 9px 0;\n  text-align: center;\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--txt3);\n  cursor: pointer;\n  border-right: 1px solid var(--b1);\n  border-bottom: 2px solid transparent\n}\n\n.modal-tab:last-child {\n  border-right: none\n}\n\n.modal-tab:hover {\n  background: var(--bg2)\n}\n\n.modal-tab.active {\n  color: var(--bl);\n  background: var(--bl5);\n  border-bottom: 2px solid var(--bl)\n}\n\n.modal-tab-content {\n  padding: 14px 18px;\n  min-height: 80px;\n  display: none;\n}\n\n.modal-tab-content.active {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 8px\n}\n\n.act-btn-modal {\n  background: var(--bl);\n  border: none;\n  border-radius: 6px;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 500;\n  padding: 9px 6px;\n  cursor: pointer;\n  text-align: center\n}\n\n.act-btn-modal:hover {\n  background: #1648c0\n}\n\n.modal-tab-content.alarmas {\n  display: none;\n  padding: 14px 18px\n}\n\n.modal-tab-content.alarmas.active {\n  display: block\n}\n\n.modal-tab-content.salud {\n  display: none;\n  padding: 14px 18px\n}\n\n.modal-tab-content.salud.active {\n  display: block\n}\n\n.empty-tab {\n  text-align: center;\n  color: var(--txt4);\n  font-size: 12px;\n  padding: 18px 0\n}\n\n/* ACTION MODAL PREMIUM */\n.action-modal-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  color: #1e293b;\n}\n\n.action-modal-header {\n  padding: 16px 20px;\n  background: var(--third-color);\n  color: white;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.action-modal-header h3 {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.action-modal-close {\n  cursor: pointer;\n  font-size: 20px;\n  line-height: 1;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n}\n\n.action-modal-close:hover {\n  opacity: 1;\n}\n\n.action-modal-body {\n  padding: 30px;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  background: #f8fafc;\n}\n\n.action-prompt {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 15px;\n}\n\n.action-icon-circle {\n  width: 64px;\n  height: 64px;\n  background: #eff6ff;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 10px;\n  border: 1px solid #dbeafe;\n}\n\n.action-ip-badge {\n  background: #1e293b;\n  color: #f1f5f9;\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-family: monospace;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.action-loading-state {\n  text-align: center;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n}\n\n.action-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  animation: spin-action 0.8s linear infinite;\n}\n\n@keyframes spin-action {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.action-result-container {\n  width: 100%;\n}\n\n.action-result-banner {\n  padding: 12px;\n  border-radius: 8px;\n  text-align: center;\n  font-weight: 700;\n  font-size: 14px;\n  margin-bottom: 20px;\n}\n\n.action-result-banner.success {\n  background: #dcfce7;\n  color: #15803d;\n  border: 1px solid #bbf7d0;\n}\n\n.action-result-banner.error {\n  background: #fee2e2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.action-details-box {\n  background: #ffffff;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  padding: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.action-detail-item {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.action-detail-item.terminal {\n  flex: 1;\n}\n\n.action-detail-item .label {\n  font-size: 10px;\n  font-weight: 700;\n  color: #94a3b8;\n  text-transform: uppercase;\n}\n\n.action-detail-item .value {\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.value-terminal {\n  background: #0f172a;\n  color: #38bdf8;\n  padding: 12px;\n  border-radius: 6px;\n  font-family: 'Consolas', 'Monaco', monospace;\n  font-size: 12px;\n  white-space: pre-wrap;\n  max-height: 150px;\n  overflow-y: auto;\n  margin: 0;\n}\n\n.action-modal-footer {\n  padding: 16px 20px;\n  background: #ffffff;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.btn-action-cancel {\n  padding: 8px 16px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n  background: #f1f5f9;\n  border: 1px solid #e2e8f0;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-action-cancel:hover {\n  background: #e2e8f0;\n}\n\n.btn-action-confirm {\n  padding: 8px 20px;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #ffffff;\n  background: var(--third-color);\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.btn-action-confirm:hover {\n  background: #002b82;\n  transform: translateY(-1px);\n}\n\n/* MONITORING TABLES (ev-table) */\n.ev-table-wrap {\n  background: white;\n  border-radius: 8px;\n  overflow: auto;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.ev-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 11px;\n}\n\n.ev-table-thead th {\n  position: sticky;\n  top: 0;\n  background: #f8fafc;\n  padding: 10px 8px;\n  text-align: left;\n  font-weight: 700;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid #e2e8f0;\n  z-index: 10;\n}\n\n.ev-table-tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n  transition: background 0.2s;\n}\n\n.ev-table-row:hover {\n  background: #f8fafc;\n  cursor: pointer;\n}\n\n.ev-table-tbody td {\n  padding: 8px;\n  vertical-align: middle;\n  color: #334155;\n}\n\n.txt-futuristic {\n  font-family: 'Outfit', sans-serif !important;\n  letter-spacing: 0.02em;\n}\n\n.ev-link {\n  color: #2563eb;\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.ev-link:hover {\n  text-decoration: underline;\n}\n\n/* SEVERITY PILLS */\n.sev-pill {\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-weight: 800;\n  font-size: 9px;\n  text-align: center;\n  color: white !important;\n  display: inline-block;\n  min-width: 32px;\n}\n\n.sev-pill.s1 {\n  background: #10b981 !important;\n}\n\n.sev-pill.s2 {\n  background: #3b82f6 !important;\n}\n\n.sev-pill.s3 {\n  background: #f59e0b !important;\n}\n\n.sev-pill.s4 {\n  background: #f97316 !important;\n}\n\n.sev-pill.s5 {\n  background: #ef4444 !important;\n}\n\n.sev-pill.s6 {\n  background: #8b5cf6 !important;\n}\n\n.sev-pill.s0 {\n  background: #94a3b8 !important;\n}\n\n.status-pill {\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-size: 9px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.status-pill.problem {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.status-pill.resolved {\n  background: #dcfce7;\n  color: #15803d;\n}\n\n.ack-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #e2e8f0;\n  margin: 0 auto;\n}\n\n.ack-dot.active {\n  background: #2563eb;\n  box-shadow: 0 0 8px rgba(37, 99, 235, 0.4);\n}\n\n/* STAT BAR NEW VARIABLES */\n:root {\n  --stat-up: #057a55;\n  --stat-unk: #64748b;\n  --stat-dwn: #db2777;\n  /* ROSA */\n  --stat-odd: #e02424;\n  /* ROJO */\n  --stat-exc: #d97706;\n}\n\n.stat-bar-new {\n  background: rgba(255, 255, 255, 0.97);\n  border-bottom: 1px solid #e2e8f0;\n  padding: 8px 14px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n  box-sizing: border-box;\n  position: absolute;\n  z-index: 10;\n}\n\n.stat-total-card {\n  display: flex;\n  flex-direction: column;\n  padding: 5px 12px;\n  min-width: 80px;\n}\n\n.stat-total-num {\n  font-size: 28px;\n  font-weight: 700;\n  color: #0f172a;\n  font-family: 'DM Mono', monospace;\n  line-height: 1;\n}\n\n.stat-total-lbl {\n  font-size: 9px;\n  font-weight: 500;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: .06em;\n}\n\n.stat-divider {\n  width: 1px;\n  height: 40px;\n  background: #e2e8f0;\n  margin: 0 8px;\n}\n\n.stat-card {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: #ffffff;\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  padding: 7px 12px;\n  min-width: 60px;\n  position: relative;\n  transition: all 0.2s ease;\n}\n\n.stat-card:hover {\n  border-color: #cbd5e1;\n  transform: translateY(-1px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);\n}\n\n.stat-card::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 3px;\n  border-radius: 8px 0 0 8px;\n}\n\n/* Modifier classes for cards */\n.stat-card.up::before {\n  background: var(--stat-up);\n}\n\n.stat-card.unk::before {\n  background: var(--stat-unk);\n}\n\n.stat-card.down::before {\n  background: var(--stat-dwn);\n}\n\n.stat-card.odd::before {\n  background: var(--stat-odd);\n}\n\n.stat-card.exc::before {\n  background: var(--stat-exc);\n}\n\n.stat-card-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-card-lbl {\n  font-size: 9px;\n  font-weight: 600;\n  color: #64748b;\n  text-transform: uppercase;\n  letter-spacing: .07em;\n  line-height: 1;\n  margin-bottom: 2px;\n}\n\n.stat-card-num {\n  font-size: 22px;\n  font-weight: 600;\n  font-family: 'DM Mono', monospace;\n  line-height: 1;\n}\n\n.stat-card-sub {\n  font-size: 8px;\n  color: #64748b;\n  margin-top: 1px;\n}\n\n/* Colors for numbers */\n.stat-card.up .stat-card-num {\n  color: var(--stat-up);\n}\n\n.stat-card.unk .stat-card-num {\n  color: var(--stat-unk);\n}\n\n.stat-card.down .stat-card-num {\n  color: var(--stat-dwn);\n}\n\n.stat-card.odd .stat-card-num {\n  color: var(--stat-odd);\n}\n\n.stat-card.exc .stat-card-num {\n  color: var(--stat-exc);\n}\n\n.stat-card-dot-wrap {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\n.stat-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n}\n\n/* Dot variants */\n.stat-card.up .stat-dot {\n  background: var(--stat-up);\n  box-shadow: 0 0 0 3px rgba(5, 122, 85, .12);\n}\n\n.stat-card.unk .stat-dot {\n  background: var(--stat-unk);\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, .12);\n}\n\n.stat-card.down .stat-dot {\n  background: var(--stat-dwn);\n  box-shadow: 0 0 0 3px rgba(219, 39, 119, .12);\n}\n\n.stat-card.odd .stat-dot {\n  background: var(--stat-odd);\n  box-shadow: 0 0 0 3px rgba(224, 36, 36, .12);\n}\n\n.stat-card.exc .stat-dot {\n  background: var(--stat-exc);\n  box-shadow: 0 0 0 3px rgba(217, 119, 6, .12);\n}\n\n/* TOOLTIP STYLES */\n.stat-tooltip {\n  visibility: hidden;\n  opacity: 0;\n  position: absolute;\n  top: 105%;\n  left: 0;\n  background: white;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  z-index: 1000;\n  width: 320px;\n  min-height: 100px;\n  max-height: 450px;\n  overflow-y: auto;\n  transition: all 0.2s ease;\n  pointer-events: none;\n}\n\n.stat-card:hover .stat-tooltip {\n  visibility: visible;\n  opacity: 1;\n  pointer-events: auto;\n  transform: translateY(5px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
